// This import is okay because it's the proxy
// eslint-disable-next-line no-restricted-imports
import type { Headers } from '@engage/graphql/client';
import { toClient as engageToClient } from '@engage/graphql/client';
import { engageApi } from '@members/data-fetch';
import { getUatApiOverrides } from '@members/env';

export const toClient = (headers?: Headers, getAuthHeader?: () => Promise<string>) =>
  engageToClient(engageApi, headers, getUatApiOverrides, getAuthHeader);
